export const initialData = {
  nome: '',
  cod_ibge: '',
  estado_id: '',
}
export default initialData;
